import React, { useRef, useEffect } from 'react';
import { Box } from '@mui/material';
import PerfectScrollbar from 'react-perfect-scrollbar';

import MensagemSuporte from './MensagemSuporte';
import MensagemCliente from './MensagemCliente';

function AreaMensagem({
  escreveMensagemSuporte = [],
  userChat,
  recebeEncerraChat,
  onReplyMessage = () => {},
}) {
  const messagesEndRef = useRef(null);

  useEffect(() => {
    if (!escreveMensagemSuporte.length) return;

    const ultima = escreveMensagemSuporte[escreveMensagemSuporte.length - 1];

    if (ultima?.serviceResp === 'disconnect') {
      recebeEncerraChat(true);
    }

    // sempre rolar pro final quando chegam mensagens
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [escreveMensagemSuporte, recebeEncerraChat]);

  return (
    <PerfectScrollbar options={{ suppressScrollX: false }}>
      <Box id="areaMensagem" sx={{ padding: 2 }}>
        {escreveMensagemSuporte.map((mensage, index) => {
          const isSuporte = mensage.usuario === 'suporte';
          const isClienteMsg =
            (mensage.name === userChat?.state.name &&
              mensage.serviceResp === 'mensage') ||
            (mensage.userName === userChat?.state.name &&
              mensage.serviceResp === 'receiveFile');

          return (
            <Box key={`${mensage.id || 'msg'}-${mensage.data || index}`}>
              {isSuporte && <MensagemSuporte mensage={mensage} onReply={onReplyMessage} />}
              {isClienteMsg && <MensagemCliente mensage={mensage} onReply={onReplyMessage} />}
            </Box>
          );
        })}

        <Box ref={messagesEndRef} sx={{ margin: 2 }} />
      </Box>
    </PerfectScrollbar>
  );
}

export default React.memo(AreaMensagem);
